import { render, staticRenderFns } from "./MainLedgerCard10.vue?vue&type=template&id=6afd5c3e"
import script from "./MainLedgerCard10.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports